import MentorshipService, { MentorshipMenteePoolMember } from './MentorshipService';

interface MentorshipQuickMenteeProfileProps {
    open: boolean;
    member: MentorshipMenteePoolMember | null;
    onClose: () => void;
    onEditTracks: () => void;
    onEditStatus: () => void;
    onRemove: () => void;
    onSendMessage: () => void;
}

const Field = ({ label, value }: { label: string; value: string }) => (
    <div className="mb-3">
        <div className="small text-muted">{label}</div>
        <div>{value}</div>
    </div>
);

const MentorshipQuickMenteeProfile = ({
    open,
    member,
    onClose,
    onEditTracks,
    onEditStatus,
    onRemove,
    onSendMessage,
}: MentorshipQuickMenteeProfileProps) => {
    const student = member?.student;
    const photo = MentorshipService.profilePictureSrc(student?.profilePicture);

    return (
        <>
            <div
                className={`iar-backdrop${open ? ' show' : ''}`}
                style={{ display: open ? 'block' : 'none' }}
                onClick={onClose}
            />
            <div
                className={`offcanvas offcanvas-end bg-white${open ? ' show' : ''}`}
                tabIndex={-1}
                style={{ width: 480, maxWidth: '95vw', visibility: open ? 'visible' : 'hidden' }}>
                <div className="offcanvas-header border-bottom">
                    <h5 className="offcanvas-title font-16 font-600 mb-0">Quick Mentee Profile</h5>
                    <button type="button" className="btn-close" aria-label="Close" onClick={onClose} />
                </div>
                <div className="offcanvas-body">
                    {!member ? (
                        <div className="text-muted">Select a mentee to view profile details.</div>
                    ) : (
                        <>
                            <div className="d-flex align-items-center gap-3 mb-4">
                                {photo ? (
                                    <img
                                        src={photo}
                                        alt=""
                                        width={64}
                                        height={64}
                                        className="rounded-circle"
                                        style={{ objectFit: 'cover' }}
                                    />
                                ) : (
                                    <div
                                        className="rounded-circle bg-light d-flex align-items-center justify-content-center"
                                        style={{ width: 64, height: 64 }}>
                                        {(student?.name || '?').slice(0, 1).toUpperCase()}
                                    </div>
                                )}
                                <div>
                                    <div className="font-18 font-600">{student?.name || '—'}</div>
                                    <div className="small text-muted">{student?.uuid || '—'}</div>
                                </div>
                            </div>

                            <Field label="Program" value={student?.programName || '—'} />
                            <Field label="Year" value={MentorshipService.displayMenteePoolYear(student?.batchYear)} />
                            <Field
                                label="Mentor Assigned"
                                value={MentorshipService.displayMenteePoolAssignedMentor(member.assignedMentor)}
                            />
                            <Field
                                label="Status"
                                value={MentorshipService.displayMenteePoolAssignmentStatus(
                                    member.confirmationStatus,
                                    member.assignmentDisplayStatus
                                )}
                            />

                            <div className="mb-3">
                                <div className="d-flex justify-content-between align-items-center">
                                    <div className="small text-muted">Career Track Interests</div>
                                    <button type="button" className="btn btn-link btn-sm p-0" onClick={onEditTracks}>
                                        Edit
                                    </button>
                                </div>
                                <div>
                                    {member.tracks.length
                                        ? member.tracks.map((track) => track.name).filter(Boolean).join(', ')
                                        : '—'}
                                </div>
                            </div>

                            <Field
                                label="Mentorship Goals"
                                value={MentorshipService.displayMenteePoolGoals(member.mentorshipGoals)}
                            />

                            <div className="d-flex flex-wrap gap-2 mt-4">
                                <button type="button" className="btn btn-outline-secondary btn-sm" onClick={onSendMessage}>
                                    Send Message
                                </button>
                                <button type="button" className="btn btn-outline-secondary btn-sm" onClick={onEditStatus}>
                                    Status
                                </button>
                                <button type="button" className="btn btn-outline-danger btn-sm" onClick={onRemove}>
                                    Remove
                                </button>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </>
    );
};

export default MentorshipQuickMenteeProfile;
